/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Add_Customer_Contract_Periods_InvalidInputs */



/**
* | output |
* | --- |
* | "At least one billing period." |
*
* @param {Partner_Add_Customer_Contract_Periods_InvalidInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_add_customer_contract_periods_invalid = /** @type {((inputs?: Partner_Add_Customer_Contract_Periods_InvalidInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Add_Customer_Contract_Periods_InvalidInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Mindestens eine Abrechnungsperiode.")
	return /** @type {LocalizedString} */ ("At least one billing period.")
});